export default __webpack_public_path__ + "assets/images/683cb6e8a32bc0a79b68c4da2ca885be.svg";